import styled from 'styled-components';
import {dFlexColumn} from '../../../../../globalVariables/GlobalFlex';

export const box = styled.section`
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-md);
    padding: var(--space-lg);
    ${dFlexColumn};
    gap: var(--space-lg);
`;

export const header = styled.header`
    ${dFlexColumn};
    gap: var(--space-xs);
`;

export const titleRow = styled.div`
    display: flex;
    align-items: center;
    gap: var(--space-sm);
`;

export const title = styled.h3`
    margin: 0;
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
    text-align: start;
`;

export const subtitle = styled.p`
    margin: 0;
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-caption);
    line-height: var(--line-height-caption);
    color: var(--TA-color-text-default);
    text-align: start;
`;
